import { pgTable, serial, text, integer, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const tenderDocumentsTable = pgTable("tender_documents", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull(),
  fileName: text("file_name").notNull(),
  fileSize: integer("file_size"),
  filePath: text("file_path"),
  extractedText: text("extracted_text"),
  openaiFileId: text("openai_file_id"),
  // OCR pipeline status for scanned PDFs:
  //   null | "pending" | "running" | "completed" | "failed" | "skipped"
  ocrStatus: text("ocr_status"),
  ocrError: text("ocr_error"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
});

export const insertTenderDocumentSchema = createInsertSchema(tenderDocumentsTable).omit({ id: true, createdAt: true });
export type InsertTenderDocument = z.infer<typeof insertTenderDocumentSchema>;
export type TenderDocument = typeof tenderDocumentsTable.$inferSelect;
